import clsx from 'clsx';
import { AdPlatform } from '@/shared/types/enums';
import { PlatformLogo, isPlatformLogoWordmark } from '@/shared/components/promote/PlatformLogo';
import styles from './PlatformTag.module.scss';

export interface PlatformTagProps {
  platform: AdPlatform;
  /** `lg` is for page headers; `sm` for list rows and cards */
  size?: 'sm' | 'lg';
  className?: string;
}

const PLATFORM_LABELS: Record<string, string> = {
  [AdPlatform.META]: 'Meta',
  [AdPlatform.GOOGLE]: 'Google',
  [AdPlatform.TWITTER]: 'X',
  [AdPlatform.TIKTOK]: 'TikTok',
};

const LOGO_SIZE: Record<'sm' | 'lg', number> = { sm: 14, lg: 20 };

export function PlatformTag({ platform, size = 'sm', className }: PlatformTagProps) {
  // X's mark already reads as its name, so that tag carries the logo alone — which
  // makes the logo itself responsible for the accessible name.
  const iconOnly = isPlatformLogoWordmark(platform);
  const label = PLATFORM_LABELS[platform] ?? platform;

  return (
    <span
      className={clsx(
        styles.tag,
        styles[size],
        styles[`platform${platform}`],
        iconOnly && styles.iconOnly,
        className,
      )}
      title={iconOnly ? label : undefined}
    >
      <PlatformLogo
        platform={platform}
        size={iconOnly ? LOGO_SIZE[size] + 1 : LOGO_SIZE[size]}
        label={iconOnly ? label : undefined}
      />
      {!iconOnly && label}
    </span>
  );
}
